import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../services/authContext";
import api from "../../../../services/api";

import '../../css/login.css';
import unlock from '../../../../media/eye1.png';
import lock from '../../../../media/eye2.png';
import Otp from '../../../../media/login_otp.png';

const Login = () => {
  const { login: setAuth } = useContext(AuthContext);
  const navigate = useNavigate();
  const [step, setStep] = useState("login"); 
  const [userId, setUserId] = useState(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [recoveryEmail, setRecoveryEmail] = useState("");
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [timeLeft, setTimeLeft] = useState(300); 

  
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    const res = await api.login({ username, password });

    setUsername("");
    setPassword("");

    if (res.success && res.requires_2fa) {
      setUserId(res.user_id);
      setStep("otp");
      setTimeLeft(300);
    } else {
      setError("Username o password non corretti.");
    }
  };

  
  const handleOtp = async (e) => {
    e.preventDefault();
    setError("");

    const res = await api.verifyOtp({
      user_id: userId,
      code: otp,
    });

    setOtp("");

    if (res.success) {
      setAuth();
      setTimeout(() => {
      navigate("/");
      window.location.reload();
    }, 150);
    } else {
      setError("Codice OTP non valido.");
    }
  };

  const handleResend = async () => {
    const res = await api.resendOtp({ user_id: userId });

    if (!res.success) {
      setError(res.message);
      return;
    }

    setError("");
    setTimeLeft(300);
  };

  
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError("");
    setInfo("");

    const res = await api.forgotPassword({
      email: recoveryEmail,
    });

    setRecoveryEmail("");

    if (res.success) {
      setStep("forgot_sent");
      setInfo("Email inviata con le istruzioni per il reset della password.");
    } else {
      setError(res.message || "Errore durante il recupero password.");
    }
  };

  
  useEffect(() => {
    if (step !== "otp") return;
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [step, timeLeft]);

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  };

  return (
    <div className="login-container">
      <div className="login-flex-wrapper">
      <h1 className="login-title">Login</h1>

      <div className="login-form-box">

        {step === "login" && (
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>Username:</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Password:</label>

              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="password-input"
                />

                <button
                  type="button"
                  onClick={() => setShowPassword(prev => !prev)}
                  className="toggle-password-btn"
                >
                  <img
                    src={showPassword ? lock : unlock}
                    alt="toggle password"
                    className="eye-icon"
                  />
                </button>
              </div>
            </div>

            {error && <p className="error">{error}</p>}

            <button type="submit" className="btn-login">
              Login
            </button>

            <button
              type="button"
              onClick={() => {
                setStep("forgot");
                setError("");
              }}
              style={{
                marginTop: "20px",
                background: "transparent",
                border: "none",
                cursor: "pointer"
              }}
            >
              Password dimenticata?
            </button>
          </form>
        )}

        {step === "otp" && (
          <form onSubmit={handleOtp}>
            <div className="form-group">
              <label>Codice OTP:</label>

              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                maxLength={6}
                required
              />

              <p>Scade tra: {formatTime(timeLeft)}</p>
              <p style={{fontSize: '14px', color: '#555', marginTop: '10px'}}>
              <img src={Otp} style={{width: '16px', height: '16px', marginRight: '5px', marginTop: '-2.5px'}} alt=""/>
              Controlla la tua mail
              </p>

              {timeLeft <= 0 && (
                <p className="error">Codice scaduto</p>
              )}
            </div>

            {error && <p className="error">{error}</p>}

            <button type="submit" className="btn-login">
              Verifica codice
            </button>

            <button
              type="button"
              onClick={handleResend}
              style={{ marginTop: "20px", border: "none", background: "transparent" }}
            >
              Reinvia codice
            </button>
          </form>
        )}

        {step === "forgot" && (
          <form onSubmit={handleForgotPassword}>
            <div className="form-group">
              <label>Email:</label>

              <input
                type="email"
                value={recoveryEmail}
                onChange={(e) => setRecoveryEmail(e.target.value)}
                required
              />
            </div>

            {error && <p className="error">{error}</p>}
            {info && <p style={{ color: "green" }}>{info}</p>}

            <button type="submit" className="btn-login">
              Recupera password
            </button>

            <button
              type="button"
              onClick={() => setStep("login")}
              style={{
                marginTop: "20px",
                background: "transparent",
                border: "none",
              }}
            >
              Torna al login
            </button>
          </form>
        )}

        {step === "forgot_sent" && (
          <div style={{ textAlign: "center" }}>
            <h3>Email inviata</h3>
            <p>Controlla la tua casella di posta per reimpostare la password.</p>

            <button
              onClick={() => setStep("login")}
              className="btn-login"
            >
              Torna al login
            </button>
          </div>
        )}

      </div>
      </div>
    </div>
  );
};

export default Login;